import { CoreStore } from "../RESTStore/CoreStore";
import { FetchError } from "General/ErrorTypes";

/**
 * This store is an instance for Data Stores that are used to store data received from back-end.
 * The idea is to use same API to manipulate in different data structures (e.g. Array, Object, Map).
 */
export abstract class CoreDataStore extends CoreStore {
  // should use only one naming for all resource types.
  abstract data;

  // resets data to it's initial state
  abstract clear();

  // url for the rest api endpoint
  abstract url(id?: number | string): string;

  // Concrete data stores keep their historical fetch argument order.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract fetch(...args: any[]);

  /**
   * Finds record in collection. Not needed in Objects.
   * @param id - value to find
   * @param idField - optional field. Used in Array data type to find record by corresponding field (e.g. "fileId")
   */
  abstract find?(id: string | number, idField?: string);

  /**
   * Edits record.
   * @param newData - Object to replace
   * @param id - value to match each record
   * @param idField - same as in "find" method
   */
  abstract edit?(id: string | number, newData: object, idField?: string): void;

  /**
   * Deletes record.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  abstract delete?(...args: any[]): void;

  /**
   * Function to handle processing of response object. For example, normalizing.
   */
  processResponse = (response) => {
    return response;
  };

  /**
   * Function to handle processing of custom error scenarios.
   */
  processError = (err: FetchError | Error) => {
    return err;
  };
}
